import { useState, useEffect } from 'react';
import { UAParser } from 'ua-parser-js';

export const useDeviceType = () => {
  const [deviceInfo, setDeviceInfo] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    deviceType: 'desktop',
    os: '',
    browser: '',
    userAgent: '',
  });

  useEffect(() => {
    const parser = new UAParser();
    const result = parser.getResult();

    const isMobile = result.device.type === 'mobile';
    const isTablet = result.device.type === 'tablet';
    const isDesktop = !isMobile && !isTablet;

    setDeviceInfo({
      isMobile,
      isTablet,
      isDesktop,
      deviceType: result.device.type || 'desktop',
      os: result.os.name || '',
      browser: result.browser.name || '',
      userAgent: result.ua,
    });
  }, []);

  return deviceInfo;
};
